import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function SeineSaintDenis93Page() {
  return <DeptPage dept={departmentsData["seine-saint-denis-93"]} />;
}
